import { ApiClient } from "@/services/apiClient";
import type { CategoryId } from "@/services/collection/categories";
import type { Parameter } from "@/services/collection/parameters/parametersTypes";

const fetchForCategory = async (categoryId: CategoryId): Promise<Parameter[]> => {
  const url = `api-public/collection/parameter`;
  return ApiClient.getPublic<Parameter[]>(url, { categoryId }).then(({ data }) => data);
};

export const Api = {
  fetchForCategory,
};
